import React from 'react';
import styled from '@emotion/styled';
import {
  TextField as BaseTextField,
  TextFieldProps,
} from '@ublend-npm/aulaui-next';
import { breakpoints } from '../GlobalStyle/GlobalStyle.styles';

const TextWieldWrapper = styled.div`
  &:first-of-type {
    margin-top: 0px;
  }
  margin-top: var(--spacing-giant);

  @media (min-width: ${breakpoints.large}) {
    margin-top: var(--spacing-x-giant);
  }
`;

export const TextField = React.forwardRef((props: TextFieldProps, ref) => (
  <TextWieldWrapper>
    <BaseTextField {...props} inputRef={ref} />
  </TextWieldWrapper>
));

export const Title = styled.span`
  line-height: 40px;

  font-size: 20px;
  font-weight: var(--font-weight-semi-bold);

  @media (min-width: ${breakpoints.large}) {
    font-size: 34px;
    font-weight: normal;
  }
`;

export const AlertContainer = styled.div`
  margin-bottom: var(--spacing-medium);
`;

export const InputForm = styled.form`
  max-width: 480px;
  width: 100%;

  margin-right: var(--spacing-x-large);
  margin-left: var(--spacing-x-large);
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: auto;
  margin-top: 34px;

  height: 100%;
  @media (min-width: ${breakpoints.large}) {
    margin-top: 0;
  }
`;

export const TextfieldContainer = styled.div`
  margin-top: 28px;

  @media (min-width: ${breakpoints.large}) {
    margin-top: 72px;
  }
`;

export const SubmitContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--spacing-giant);
`;

export const SignupButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TOSContainer = styled.div`
  line-height: 16px;

  font-family: var(--font);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-small);
  color: var(--black-opacity60);
  margin-bottom: var(--spacing-small);
`;

export const TOSLink = styled.a`
  color: var(--purple);
  text-decoration: none;
`;
